import http from './http';

/**
 * 上传相关接口
 */

/**
 * 构造上传请求的 query 串
 * @param {object} o 上传参数
 * @param {boolean|string} o.serverCompress
 * @param {string} o.uploadChannel
 * @param {string} [o.channelName]
 * @param {string} o.uploadNameType
 * @param {boolean|string} o.autoRetry
 * @param {string} o.uploadFolder
 * @param {object} [o.extra] 额外 query（如 { initChunked: true }）
 */
export function buildUploadQuery({ serverCompress, uploadChannel, channelName, uploadNameType, autoRetry, uploadFolder, extra = {} }) {
  const qs = new URLSearchParams();
  qs.set('serverCompress', serverCompress);
  qs.set('uploadChannel', uploadChannel);
  if (channelName) qs.set('channelName', channelName);
  qs.set('uploadNameType', uploadNameType);
  qs.set('autoRetry', autoRetry);
  qs.set('uploadFolder', String(uploadFolder));
  for (const [k, v] of Object.entries(extra)) {
    if (v !== undefined) qs.set(k, v);
  }
  return qs.toString();
}

/** 直接上传（FormData），支持进度回调与取消 */
export function upload(formData, query, { signal, onUploadProgress } = {}) {
  return http.post(`/api/upload?${query}`, formData, {
    signal,
    onUploadProgress,
  });
}

/** 清理分片上传残留资源 */
export function cleanupUpload(uploadId, totalChunks) {
  return http.get('/api/upload', {
    params: { cleanup: true, uploadId, totalChunks },
    timeout: 5000,
  });
}

/** URL 抓取上传（粘贴链接直接入库） */
export function fetchRes(url, config = {}) {
  return http.post('/api/system/fetchRes', { url }, config);
}

/** HuggingFace 渠道：预检并获取上传地址 */
export function hfGetUploadUrl(data, config = {}) {
  return http.post('/api/upload/huggingface/getUploadUrl', data, config);
}

/** HuggingFace 渠道：提交上传 */
export function hfCommitUpload(data, config = {}) {
  return http.post('/api/upload/huggingface/commitUpload', data, config);
}
